<template>
  <div class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="top" />
    <div id="printContainer">
      <div class="detalle_remito">
        <img :src="collapsedLogoImg" alt="" height="46" class="float-right mr-2 logoImg">
        <h2 v-if="customListTitle">{{ customListTitle }}</h2>
        <h2 v-else>{{ title }}</h2>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <h4 v-for="(subTitle, index) in customListSubTitles" :key="index">{{ subTitle }}</h4>
        <LmTableCustom v-if="!loading"
          :order = order
          :orderBySetting = orderBySetting
          :searchOnFields = searchOnFields
          :perPageSetting = perPageSetting
          :itemsPerPage = defaultItemsPerPage
          :limitExportFromClient = limitExportFromClient
          :apiCallPath = apiCallPath
          :highlight = highlight
          :showFilterTime = showFilterTime
          :showGoBackButton = showGoBackButton
          :showPDFButton = showPDFButton
          :showCSVButton = showCSVButton
          :hideSearchSection = hideSearchSection
          :downloadCsvFileName = downloadCsvFileName
          :lmListActions = lmListActions
          />
      </div>
    </div>
    <LmForm>
      <LmButton
        v-if="this.tableItems.length"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar Seleccionados"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        :disabled="isSendButtonDisabled"
        @click.native="firmar"
        />
      <LmButton
        v-if="false && this.tableItems.length"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Rechazar Seleccionados"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        :disabled="isSendButtonDisabled"
        @click.native="cancelar"
        />
    </LmForm>
    <lmConfirmationModal ref="lmConfirmationModalFirmar" title="Aviso" :message="confirmationModalMessage"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmForm from '@/components/form/LmForm.vue'
import LmTableCustom from '@/components/LmTableCustom'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'

export default {
  mixins: [lmSuperPowerSelectHelper],
  components: {
    LmForm,
    LmButton,
    LmTableCustom,
    LmDateTime,
    LmDate,
    lmConfirmationModal,
    LmSuperPowerSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      formIsProcessing: false,
      top: 0
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'tableItems', 'customListTitle', 'customListSubTitles', 'loading']),
    ...mapState('settings', ['collapsedLogoImg']),
    ...mapState('settings', [
      'listTitle',
      'order',
      'orderBySetting',
      'searchOnFields',
      'perPageSetting',
      'defaultItemsPerPage',
      'limitExportFromClient',
      'loading',
      'highlight',
      'apiCallPath',
      'actions',
      'showFilterTime',
      'showGoBackButton',
      'showPDFButton',
      'showCSVButton',
      'downloadCsvFileName',
      'lmListActions',
      'hideSearchSection',
      'hideBreadcrumb',
      'createSegment'
    ]),
    isSendButtonDisabled () {
      return this.tableItems.length === 0 || this.tableItems.filter(i => i.lmChecked).length === 0
    },
    decretosSeleccionados () {
      return this.tableItems.filter(i => i.lmChecked)
    },
    decretosSeleccionadosSize () {
      return this.tableItems.filter(i => i.lmChecked).length
    },
    confirmationModalMessage () {
      return `Va a iniciar el proceso de firma para ${this.decretosSeleccionadosSize} resolucion${this.decretosSeleccionadosSize > 1 ? 'es' : ''}. ¿Está seguro?`
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    listEndpointUri: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: false,
      default: '/'
    },
    jnlpGeneratorPath: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings', 'getListSettings']),
    ...mapActions('session', ['getUserInfo']),
    async firmar () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmar.lmShow()
        const tempLink = document.createElement('a')
        tempLink.href = `${this.jnlpGeneratorPath}${this.decretosSeleccionados.map(d => parseInt(d.hidden_n_transac)).join('&id=')}`
        tempLink.setAttribute('download', `decretos-multiples.jnlp`)
        tempLink.click()
        this.formIsProcessing = false
        // this.lmToastSuccessInternalLink(`/decretos/detail/${this.$route.params.id}`, 'Ver Detalle', 'Decreto enviado al firmador')
        // setTimeout(() => {
        //   this.$router.push('/decretos/firmar')
        // }, 1000)
      } catch (error) {
        this.formIsProcessing = false
      }
    }
  },
  async created () {
    this.getListSettings(this.listEndpointUri)
  }
}
</script>
<style lang="sass" scoped>
  .logoImg
    display: none
</style>
